<div
    *ngIf="value"
    class="agpr-includeExcludeSourcePicker ui-chips ui-widget"
    [class.agpr-includeExcludeSourcePicker--chips]="value.length > 0"
    [ngClass]="styleClass"
>
    <div class="agpr-includeExcludeSourcePicker-inputs">
        <agpr-dropdown
            [id]="id + '.dropdown'"
            [options]="dropdownOptions"
            optionLabel="name"
            [ariaLabel]="dropdownAriaLabel"
            [(ngModel)]="dropdownOption"
            (ngModelChange)="dropdownMenuChanged($event.value)"
        ></agpr-dropdown>
        <div class="agpr-includeExcludeSourcePicker-input agpr-inputGroupRow">
            <div class="agpr-inputGroupRow-input">
                <agpr-text-input
                    *ngIf="!showAutocomplete"
                    [id]="id + '.textInput'"
                    [placeholder]="_placeholder"
                    [disabled]="disabled"
                    [(ngModel)]="formData.textboxValue"
                    [bottomMargin]="false"
                    [ariaInvalid]="ariaInvalid"
                    [ariaDescribedBy]="ariaDescribedBy"
                    (keydown)="onKeyDown($event)"
                    (blur)="addChips()"
                ></agpr-text-input>
                <agpr-autocomplete
                    *ngIf="showAutocomplete"
                    [id]="id + '.autoComplete'"
                    labelField="name"
                    [placeholder]="_placeholder"
                    [dropdown]="true"
                    [(ngModel)]="selectedSourceGroup"
                    [suggestions]="sourceGroupList$"
                    [multiSelection]="false"
                    (itemSelected)="sourceGroupSelected($event)"
                    ariaLabel="SourceGroup.picker.placeholder"
                    [ariaInvalid]="ariaInvalid"
                    [ariaDescribedBy]="ariaDescribedBy"
                ></agpr-autocomplete>
            </div>
            <div
                class="agpr-inputGroupRow-buttons"
                *ngIf="showManageIcon"
            >
                <agpr-button
                    icon="fa-regular fa-duotone fa-gear"
                    [id]="id + '_manageDialog'"
                    [style]="buttonTypes.block"
                    (click)="showManageDialog()"
                    tooltip="Source.manageDialog.header"
                    tooltipPosition="top"
                ></agpr-button>
            </div>
        </div>
    </div>
    @if (chips.length > 0) {
        <ul class="agpr-includeExcludeSourcePicker-chips">
            @for (chip of chips; track chip; let i = $index) {
                @if (chip.entityType === sourceTypes.sourceGroups) {
                    <li>
                        <agpr-source-group-chip
                            [id]="id + '_sourceChips_' + i"
                            [groupId]="+chip.entityName"
                            (remove)="removeChip(chip)"
                        ></agpr-source-group-chip>
                    </li>
                } @else {
                    <li class="agpr-chip">
                        <span
                            [pTooltip]="chip.displayString + ' ' + typeToStringMap[chip.entityType]"
                            class="agpr-chip-label"
                        >
                            {{ chip.displayString }}
                        </span>
                        <span class="agpr-chip-type">{{ typeToStringMap[chip.entityType] }}</span>
                        <button
                            [id]="id + '_sourceChips_' + i + '_delete'"
                            class="agpr-chip-icon agpr-i-close"
                            agprTooltip="Common.forms.chips.delete"
                            [useTooltipAsAriaLabel]="false"
                            tooltipPosition="top"
                            (click)="removeChip(chip)"
                            [attr.aria-label]="chip.displayString + ' ' + ('Common.forms.chips.delete' | localize)"
                        ></button>
                    </li>
                }
            }
        </ul>
    }
</div>
